<template>
    <collapsible-card :title="'Time Spent at Platforms for the Last 30 Days'" v-show="showChart" ref="cCard">
        <div class="cardContent centerChart chartContent">
            <div class="chart">
                <div id="platformChart" v-show="showChart"></div>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import Highcharts from 'highcharts';
import { formatMinutes } from '../../helpers/Formatting.js';
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: "vessel-chart-platforms",
    components: {
        CollapsibleCard
    },
    data: () => ({
        showChart: false,
    }),
    methods: {
        createChart: function(platformTimeData) {
            var globv = this;
            globv.showChart = false;
            if (platformTimeData && platformTimeData.length > 0) {
                let data = [];
                let totalMin = 0;

                for (let p in platformTimeData) {
                    data.push({
                        name: platformTimeData[p]['platform'],
                        y: platformTimeData[p]['time'],
                        custom: {
                            time: formatMinutes(platformTimeData[p]['time'])
                        }
                    });
                    totalMin += platformTimeData[p]['time'];
                }

                for (let d in data) {
                    data[d]['custom']['percentage'] = (data[d]['y'] / totalMin * 100).toFixed(2) + '%'
                }

                Highcharts.theme = {
                    colors: [
                        "#ED4553",
                        "#2B76DE",
                        "#6DDF76",
                        "#FC7C73",
                        "#409BC9",
                        "#F8B18B",
                        "#86E1E4",
                        "#F7D8BB",
                        "#CDEAE5",
                        "#F1FAEE"
                    ]
                }

                Highcharts.setOptions(Highcharts.theme);

                Highcharts.chart('platformChart', {
                    chart: {
                        type: 'pie',
                        backgroundColor: '#22293d'
                    },
                    credits: {
                        enabled: false,
                        credits: false
                    },
                    title: {
                        text: null
                    },
                    tooltip: {
                        pointFormat:
                            'Percentage: {point.options.custom.percentage} <br/>' + 
                            'Time: {point.options.custom.time}'
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: false,
                            },
                            showInLegend: true
                        }
                    },
                    legend: {
                        itemStyle: {
                            color: "#fff"
                        }
                    },
                    series: [{
                        name: 'Platforms',
                        data: data
                    }]
                });

                globv.showChart = true;
                globv.$refs.cCard.adjustHeight();
            }
        },
        reset: function() {
            var globv = this;
            globv.showChart = false;
        }
    }
}
</script>